// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --mrt-bg: #f5f7fb;
  --mrt-surface: #ffffff;
  --mrt-surface-2: #f9fafb;
  --mrt-text: #111827;
  --mrt-text-2: #374151;
  --mrt-muted: #6b7280;
  --mrt-border: #e5e7eb;
  --mrt-border-2: #eef2f7;
  --mrt-hover: #f8fafc;
  --mrt-active: #eef2ff;
  --mrt-btn-bg: #111827;
  --mrt-btn-text: #ffffff;
  --mrt-danger: #b91c1c;
  --mrt-danger-border: #fee2e2;
  --mrt-overlay: rgba(2, 6, 23, 0.62);
  --mrt-code-bg: #0b1220;
  --mrt-code-text: #e2e8f0;
  --mrt-primary: #2563eb;
  --mrt-primary-contrast: #ffffff;
  --mrt-field-bg: #f8fafc;
  --mrt-field-bg-strong: #eef2f7;
  --mrt-warn-bg: #fff7ed;
  /* ✅ (요청) 산뜻한 민트 톤 팔레트 */
  /* ✅ 투명도(알파) 높임: 같은 색감(#F5FCF8 계열)인데 더 가볍게 보이도록 */
  --mrt-accent-bg: rgba(245, 252, 248, 0.55);      /* 패널 배경 */
  --mrt-accent-bg-2: rgba(245, 252, 248, 0.42);    /* 내부 카드/표 래퍼 */
  --mrt-accent-pill: rgba(245, 252, 248, 0.60);    /* 라벨 pill */
  --mrt-accent-field: rgba(245, 252, 248, 0.68);   /* 입력/셀 배경 */
  --mrt-accent-border: rgba(216, 233, 224, 0.72);  /* 보더 */
  --mrt-accent-focus: rgba(16, 185, 129, 0.14); /* focus ring */
  /* ✅ primary(헤더 등) 위에서 쓰는 '박스 아이콘/칩' 글래스 효과 */
  --mrt-on-primary-glass: rgba(255, 255, 255, 0.14);
  --mrt-on-primary-border: rgba(255, 255, 255, 0.22);
  --mrt-on-primary-divider: rgba(255, 255, 255, 0.18);
}

:root[data-theme='dark'] {
  /* ✅ 기본 다크 팔레트(메뉴바 색상은 Schedule.css에서만 별도 적용) */
  --mrt-bg: #0f172a;
  --mrt-surface: #16213a;
  --mrt-surface-2: #1a2a4a;
  /* ✅ 다크모드 텍스트는 너무 새하얗지 않게 살짝 톤다운(눈 피로 감소) */
  --mrt-text: #d2d7e0;
  --mrt-text-2: #b9c2d0;
  --mrt-muted: #94a3b8;
  --mrt-border: rgba(148, 163, 184, 0.22);
  --mrt-border-2: rgba(148, 163, 184, 0.18);
  --mrt-hover: rgba(148, 163, 184, 0.10);
  --mrt-active: rgba(99, 102, 241, 0.22);
  --mrt-btn-bg: #e5e7eb;
  --mrt-btn-text: #0b1220;
  --mrt-danger: #fca5a5;
  --mrt-danger-border: rgba(248, 113, 113, 0.25);
  --mrt-overlay: rgba(0, 0, 0, 0.70);
  --mrt-code-bg: #050a14;
  --mrt-code-text: #d6dde8;
  --mrt-primary: #60a5fa;
  --mrt-primary-contrast: #0b1220;
  --mrt-field-bg: #0f1b33;
  --mrt-field-bg-strong: #0b162b;
  --mrt-warn-bg: rgba(245, 158, 11, 0.14);
  /* ✅ 다크모드: 민트는 너무 튀지 않게(보수적으로) */
  --mrt-accent-bg: rgba(16, 185, 129, 0.08);
  --mrt-accent-bg-2: rgba(16, 185, 129, 0.06);
  --mrt-accent-pill: rgba(16, 185, 129, 0.10);
  --mrt-accent-field: rgba(2, 6, 23, 0.20);
  --mrt-accent-border: rgba(16, 185, 129, 0.20);
  --mrt-accent-focus: rgba(16, 185, 129, 0.18);
  /* ✅ 다크모드에서는 primary가 밝아서, 박스 아이콘/칩은 '검정 글래스'로 톤다운 */
  --mrt-on-primary-glass: rgba(0, 0, 0, 0.12);
  --mrt-on-primary-border: rgba(0, 0, 0, 0.18);
  --mrt-on-primary-divider: rgba(0, 0, 0, 0.14);
}


`, "",{"version":3,"sources":["webpack://./src/theme/theme.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,sBAAsB;EACtB,wBAAwB;EACxB,mBAAmB;EACnB,qBAAqB;EACrB,oBAAoB;EACpB,qBAAqB;EACrB,uBAAuB;EACvB,oBAAoB;EACpB,qBAAqB;EACrB,qBAAqB;EACrB,uBAAuB;EACvB,qBAAqB;EACrB,4BAA4B;EAC5B,mCAAmC;EACnC,sBAAsB;EACtB,wBAAwB;EACxB,sBAAsB;EACtB,+BAA+B;EAC/B,uBAAuB;EACvB,8BAA8B;EAC9B,sBAAsB;EACtB,wBAAwB;EACxB,iDAAiD;EACjD,0CAA0C,OAAO,UAAU;EAC3D,4CAA4C,KAAK,eAAe;EAChE,4CAA4C,KAAK,YAAY;EAC7D,6CAA6C,IAAI,YAAY;EAC7D,8CAA8C,GAAG,OAAO;EACxD,4CAA4C,EAAE,eAAe;EAC7D,6CAA6C;EAC7C,iDAAiD;EACjD,kDAAkD;EAClD,mDAAmD;AACrD;;AAEA;EACE,+CAA+C;EAC/C,iBAAiB;EACjB,sBAAsB;EACtB,wBAAwB;EACxB,2CAA2C;EAC3C,mBAAmB;EACnB,qBAAqB;EACrB,oBAAoB;EACpB,uCAAuC;EACvC,yCAAyC;EACzC,sCAAsC;EACtC,sCAAsC;EACtC,qBAAqB;EACrB,uBAAuB;EACvB,qBAAqB;EACrB,8CAA8C;EAC9C,kCAAkC;EAClC,sBAAsB;EACtB,wBAAwB;EACxB,sBAAsB;EACtB,+BAA+B;EAC/B,uBAAuB;EACvB,8BAA8B;EAC9B,uCAAuC;EACvC,gCAAgC;EAChC,yCAAyC;EACzC,2CAA2C;EAC3C,2CAA2C;EAC3C,wCAAwC;EACxC,6CAA6C;EAC7C,4CAA4C;EAC5C,oDAAoD;EACpD,2CAA2C;EAC3C,4CAA4C;EAC5C,6CAA6C;AAC/C","sourcesContent":[":root {\n  --mrt-bg: #f5f7fb;\n  --mrt-surface: #ffffff;\n  --mrt-surface-2: #f9fafb;\n  --mrt-text: #111827;\n  --mrt-text-2: #374151;\n  --mrt-muted: #6b7280;\n  --mrt-border: #e5e7eb;\n  --mrt-border-2: #eef2f7;\n  --mrt-hover: #f8fafc;\n  --mrt-active: #eef2ff;\n  --mrt-btn-bg: #111827;\n  --mrt-btn-text: #ffffff;\n  --mrt-danger: #b91c1c;\n  --mrt-danger-border: #fee2e2;\n  --mrt-overlay: rgba(2, 6, 23, 0.62);\n  --mrt-code-bg: #0b1220;\n  --mrt-code-text: #e2e8f0;\n  --mrt-primary: #2563eb;\n  --mrt-primary-contrast: #ffffff;\n  --mrt-field-bg: #f8fafc;\n  --mrt-field-bg-strong: #eef2f7;\n  --mrt-warn-bg: #fff7ed;\n  /* ✅ (요청) 산뜻한 민트 톤 팔레트 */\n  /* ✅ 투명도(알파) 높임: 같은 색감(#F5FCF8 계열)인데 더 가볍게 보이도록 */\n  --mrt-accent-bg: rgba(245, 252, 248, 0.55);      /* 패널 배경 */\n  --mrt-accent-bg-2: rgba(245, 252, 248, 0.42);    /* 내부 카드/표 래퍼 */\n  --mrt-accent-pill: rgba(245, 252, 248, 0.60);    /* 라벨 pill */\n  --mrt-accent-field: rgba(245, 252, 248, 0.68);   /* 입력/셀 배경 */\n  --mrt-accent-border: rgba(216, 233, 224, 0.72);  /* 보더 */\n  --mrt-accent-focus: rgba(16, 185, 129, 0.14); /* focus ring */\n  /* ✅ primary(헤더 등) 위에서 쓰는 '박스 아이콘/칩' 글래스 효과 */\n  --mrt-on-primary-glass: rgba(255, 255, 255, 0.14);\n  --mrt-on-primary-border: rgba(255, 255, 255, 0.22);\n  --mrt-on-primary-divider: rgba(255, 255, 255, 0.18);\n}\n\n:root[data-theme='dark'] {\n  /* ✅ 기본 다크 팔레트(메뉴바 색상은 Schedule.css에서만 별도 적용) */\n  --mrt-bg: #0f172a;\n  --mrt-surface: #16213a;\n  --mrt-surface-2: #1a2a4a;\n  /* ✅ 다크모드 텍스트는 너무 새하얗지 않게 살짝 톤다운(눈 피로 감소) */\n  --mrt-text: #d2d7e0;\n  --mrt-text-2: #b9c2d0;\n  --mrt-muted: #94a3b8;\n  --mrt-border: rgba(148, 163, 184, 0.22);\n  --mrt-border-2: rgba(148, 163, 184, 0.18);\n  --mrt-hover: rgba(148, 163, 184, 0.10);\n  --mrt-active: rgba(99, 102, 241, 0.22);\n  --mrt-btn-bg: #e5e7eb;\n  --mrt-btn-text: #0b1220;\n  --mrt-danger: #fca5a5;\n  --mrt-danger-border: rgba(248, 113, 113, 0.25);\n  --mrt-overlay: rgba(0, 0, 0, 0.70);\n  --mrt-code-bg: #050a14;\n  --mrt-code-text: #d6dde8;\n  --mrt-primary: #60a5fa;\n  --mrt-primary-contrast: #0b1220;\n  --mrt-field-bg: #0f1b33;\n  --mrt-field-bg-strong: #0b162b;\n  --mrt-warn-bg: rgba(245, 158, 11, 0.14);\n  /* ✅ 다크모드: 민트는 너무 튀지 않게(보수적으로) */\n  --mrt-accent-bg: rgba(16, 185, 129, 0.08);\n  --mrt-accent-bg-2: rgba(16, 185, 129, 0.06);\n  --mrt-accent-pill: rgba(16, 185, 129, 0.10);\n  --mrt-accent-field: rgba(2, 6, 23, 0.20);\n  --mrt-accent-border: rgba(16, 185, 129, 0.20);\n  --mrt-accent-focus: rgba(16, 185, 129, 0.18);\n  /* ✅ 다크모드에서는 primary가 밝아서, 박스 아이콘/칩은 '검정 글래스'로 톤다운 */\n  --mrt-on-primary-glass: rgba(0, 0, 0, 0.12);\n  --mrt-on-primary-border: rgba(0, 0, 0, 0.18);\n  --mrt-on-primary-divider: rgba(0, 0, 0, 0.14);\n}\n\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
